import { error } from '@/services/Log'
import axios from 'axios'
import { SHOP_ORIGIN } from '../Configuration'

export const rawCartAddCustomItem = async ({
  cartId,
  items,
  quoteIds,
}: {
  cartId: string,
  quoteIds: readonly string[],
  items: readonly {
    name: string,
    sku: string,
    quantity: number,
    price: number,
  }[]
}) => {
  try {
    await axios.post(`${SHOP_ORIGIN}/oauth/sf/cart/custom-item`, {
      cartId,
      quoteIds,
      items,
    })
    return {
      success: true,
    }
  } catch (err) {
    error('Failed to remove the item from the cart')
  }
  return { success: false }
}

export default rawCartAddCustomItem
